import { cn } from '@/lib';
import { ButtonHTMLAttributes, ReactNode } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    icon?: ReactNode;
}

export const Button = ({ children, className, icon, ...rest }: Props) => {
    return (
        <button
            className={cn(
                'text-brand-main hover:text-brand-main/80 flex w-fit cursor-pointer flex-nowrap items-center gap-1 overflow-hidden px-4 py-2 text-sm font-bold whitespace-nowrap transition-colors duration-100 ease-linear',
                className
            )}
            {...rest}
        >
            {icon && <span className='text-md flex-shrink-0'>{icon}</span>}
            <span className='overflow-hidden text-ellipsis'>{children}</span>
        </button>
    );
};
